"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReducer = exports.createDefaultStoreState = exports.createStoreState = exports.StatusCode4xx = void 0;
// eslint-disable-next-line no-shadow
var StatusCode4xx;
(function (StatusCode4xx) {
    StatusCode4xx["FourZeroZero"] = "FourZeroZero";
    StatusCode4xx["FourZeroOne"] = "FourZeroOne";
    StatusCode4xx["FourZeroThree"] = "FourZeroThree";
    StatusCode4xx["FourZeroFour"] = "FourZeroFour";
})(StatusCode4xx = exports.StatusCode4xx || (exports.StatusCode4xx = {}));
function createStoreState(storePrefix) {
    var upperCase = storePrefix.toUpperCase();
    return {
        LOADING: upperCase + "_STORE_LOADING",
        ERROR: upperCase + "_STORE_ERROR",
        SUCCESS: upperCase + "_STORE_SUCCESS"
    };
}
exports.createStoreState = createStoreState;
function createDefaultStoreState(item) {
    return {
        loading: false,
        error: null,
        data: item
    };
}
exports.createDefaultStoreState = createDefaultStoreState;
function createReducer(state, action, storeState, errorAction) {
    switch (action.type) {
        case storeState.ERROR:
            if (errorAction) {
                errorAction(action.error);
            }
            return __assign(__assign({}, state), { error: action.error, loading: false });
        case storeState.LOADING:
            return __assign(__assign({}, state), { loading: true, error: null });
        case storeState.SUCCESS:
            return __assign(__assign({}, state), { loading: false, error: null, data: action.data });
        default:
            return state;
    }
}
exports.createReducer = createReducer;
